module.exports = __webpack_public_path__ + "img/materials-and-equipments-requests.70a7fe03.svg";